import { Button, Typography } from "@mui/material";
import MButton from "components/momentum/MButton";
import TinyMCEController from "components/summary/success-plan/components/workflow/TinyMCEController";
import { useState } from "react";
import { Control, UseFormSetValue } from "react-hook-form";
import styles from "./SuccessPlanWorkflow.module.scss";
import HistoryListRenderer from "components/summary/success-plan/components/workflow/HistoryListRenderer";

type NoteEditWrapperProps = {
  label: string;
  name: string;
  required: boolean;
  histories: any[];
  control: Control;
  setValue: UseFormSetValue<any>;
};

const NoteEditWrapper = ({
  label,
  name,
  required,
  histories,
  control,
  setValue,
}: NoteEditWrapperProps) => {
  const [toggleNotes, setToggleNotes] = useState(false);

  const handleToggleNotes = () => {
    setToggleNotes(!toggleNotes);
  };

  const handleCopyNote = (noteContent: string) => {
    setValue(name, noteContent);
  };

  const latestNote = histories.length && histories.length > 0 ? histories[0].newValue : "";

  return (
    <div className={styles["flex-vertical-gap"]}>
      <div className={styles["form-field-wrapper"]}>
        <Typography className={styles["form-field-label"]}>{label}</Typography>
        {required && <Typography className={styles["form-field-star"]}>*</Typography>}
      </div>
      <TinyMCEController
        name={name}
        control={control}
        required={required}
      />
      {histories.length > 0 && (
        <div className={styles["flex-space"]}>
          <MButton
            buttonType="blue"
            onClick={() => handleCopyNote(latestNote)}
          >
            Copy Previous Note
          </MButton>
          <Button
            onClick={handleToggleNotes}
            disableRipple
            disableTouchRipple
            disableFocusRipple
            sx={{
              textTransform: "none",
              ":hover": { backgroundColor: "transparent" },
              fontSize: "12px",
            }}
          >
            {toggleNotes ? "Hide Previous Notes" : "View Previous Notes"}
          </Button>
        </div>
      )}
      <div className={styles["flex-vertical-gap"]}>
        {toggleNotes && <HistoryListRenderer noteHistories={histories} />}
      </div>
    </div>
  );
};

export default NoteEditWrapper;
